module.exports = require('./_global');



// WEBPACK FOOTER //
// ./~/core-js/modules/_path.js